export default __webpack_public_path__ + "static/media/designOpsLogo.77d393e7.svg";